// extracted by mini-css-extract-plugin
module.exports = {"logoLink":"jG","logoWrapper":"jH"};